import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";
import { errorAlert } from "../Components/Alerts";

export const getSystemModules = async (headers) => {
  try {
    const response = await axios.get(
      ApiLink.API_URL + "License/getSystemModule",
      { headers }
    );    
    return response.data; // ← DUHET TË KTHEHET KJO
  } catch (error) {
    errorAlert("Gabim në kërkesë:", error);

    if (error.response?.data?.errorMessage) {
      errorAlert(`Gabim: ${error.response.data.errorMessage}`);
    } else if (error.message) {
      errorAlert(`Gabim: ${error.message}`);
    } else {
      errorAlert("Gabim i panjohur.");
    }
    return null;
  }
};
